import React from 'react';
import { withNamespaces } from 'react-i18next';
import i18n from "i18next";

const IndividualAccommodationDetail = request => (
  <div className="content table-responsive table-full-width">
    <table className="table table-hover table-bordered">
      <tbody>
        <tr>
          <td>
              {i18n.t('isThereAccommodation')}
          </td>
          <td id="individualAccommodationDetailDays">
            {request.request.individualAccommodationDays > 0
              ? (`${request.request.individualAccommodationDays} gün`)
              : 'Yok'
                        }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default withNamespaces()(IndividualAccommodationDetail);



// WEBPACK FOOTER //
// ./src/components/travel-expense/detail/individual-accommodation/index.js